import {IBoosterCategory} from "../types/IBoosterCategory";

export const gtmBoosterCategoryMap = {
    [IBoosterCategory.OfferStats]: "Parametr mieszkania",
    [IBoosterCategory.BigDataStats]: "Zainteresowanie / Kontakt",
    [IBoosterCategory.Promotion]: "Promocja"
};
import {IBoosterCategory} from "../types/IBoosterCategory";

export const gtmBoosterCategoryMap = {
    [IBoosterCategory.OfferStats]: "Parametr mieszkania",
    [IBoosterCategory.BigDataStats]: "Zainteresowanie / Kontakt",
    [IBoosterCategory.Promotion]: "Promocja"
};
